// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__giRuO","validationTips":"StatementDescriptor_validationTips__32P-G"};